import { Toasts } from "components"
import { FormHelpers } from "utility/form-helpers"
import { WarningIcon } from "../icons"


const el = {
  root: document.querySelector('.checkout-layout--insurance'),
  proceedButtons: document.querySelectorAll<HTMLButtonElement>('#checkout-sidebar-proceed-button, #checkout-footer-proceed-button'),
  cartItems: document.querySelectorAll<HTMLDivElement>('.checkout-layout--insurance .cart-item'),
}

export const CheckoutInsurance = {

  init: () => {
    if (!el.root) return
    CheckoutInsurance.activateCartItems()
  },

  activateCartItems: () => {
    el.cartItems.forEach(target => {
      const addInsuranceForm = target.querySelector<HTMLFormElement>('.add-insurance-form')
      const updateInsuranceForm = target.querySelector<HTMLFormElement>('.update-insurance-form')
      const radios = target.querySelectorAll<HTMLInputElement>('.radio-card__input')

      if (!addInsuranceForm) return

      radios.forEach(target => target.addEventListener('change', () => CheckoutInsurance.onRadioChange({ form: addInsuranceForm })))

      if (!updateInsuranceForm) return

      const quantityInput = updateInsuranceForm.querySelector<HTMLInputElement>('.stepper__input')
      const incrementButton = updateInsuranceForm.querySelector<HTMLButtonElement>('.action-button--increment')
      const decrementButton = updateInsuranceForm.querySelector<HTMLButtonElement>('.action-button--decrement')

      if (!quantityInput || !incrementButton || !decrementButton) return

      updateInsuranceForm.addEventListener('submit', CheckoutInsurance.onUpdateQuantitySubmit)
      incrementButton.addEventListener('click', () => CheckoutInsurance.onIncrement({
        input: quantityInput,
        form: updateInsuranceForm,
      }))
      decrementButton.addEventListener('click', () => CheckoutInsurance.onDecrement({
        input: quantityInput,
        form: updateInsuranceForm,
      }))
    })
  },

  onRadioChange: ({ form }: { form: HTMLFormElement }) => {
    CheckoutInsurance.submitForm({ form, type: 'add-insurance' })
  },

  onUpdateQuantitySubmit: (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault()
    CheckoutInsurance.submitForm({
      form: e.target,
      type: 'change-insurance',
    })
  },

  submitForm: ({ form, type }: {
    form: HTMLFormElement,
    type: 'add-insurance' | 'change-insurance'
  }) => {
    const input = form.querySelector<HTMLInputElement>('.stepper__input')

    FormHelpers.submitForm({
      form,
      buttons: Array.from(el.proceedButtons),
      onSuccess: () => window.location.reload(),
      onError: (message = '') => {
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: message
            ? message
            : type === 'add-insurance'
              ? 'Ekki tókst að velja viðbótartryggingu.'
              : 'Ekki tókst að breyta tryggingafjölda.',
          icon: WarningIcon(),
        })

        // set input value to old value if request fails
        if (!input || type !== 'change-insurance') return
        const { oldvalue: oldValue = '' } = input.dataset
        if (!oldValue) return
        input.value = oldValue
      },
    })
  },

  onIncrement: ({ input, form }: {
    input: HTMLInputElement,
    form: HTMLFormElement
  }) => {
    try {
      const maxValue = parseInt(input.max)
      const newValue = parseInt(input.value) + 1
      if (newValue > maxValue) return
      input.value = `${newValue}`
      CheckoutInsurance.submitForm({ form, type: 'change-insurance' })
    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Ekki tókst að breyta tryggingafjölda.',
        icon: WarningIcon(),
      })
    }
  },

  onDecrement: ({ input, form }: {
    input: HTMLInputElement,
    form: HTMLFormElement
  }) => {
    try {
      const oldValue = parseInt(input.value)
      if (oldValue <= 1) return
      input.value = `${oldValue - 1}`
      CheckoutInsurance.submitForm({ form, type: 'change-insurance' })
    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Ekki tókst að breyta tryggingafjölda.',
        icon: WarningIcon(),
      })
    }
  },

  onInputBlur: ({ input, form }: {
    input: HTMLInputElement,
    form: HTMLFormElement,
  }) => {
    try {
      const { oldvalue = '' } = input.dataset

      const oldValue = parseInt(oldvalue)
      const maxValue = parseInt(input.max)
      const currentValue = parseInt(input.value)

      if (oldValue === currentValue) return

      // set input value to old value if value is zero or if value is higher than max
      if (currentValue === 0 || currentValue > maxValue) {
        input.value = oldValue.toString()
        return
      }

      CheckoutInsurance.submitForm({ form, type: 'change-insurance' })
    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Ekki tókst að breyta tryggingafjölda.',
        icon: WarningIcon(),
      })
    }
  },

}